export default __webpack_public_path__ + "static/media/styledcomponents.186b514d.png";